import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, CheckCircle2, FileText } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { Hero } from "@/components/site/Hero";
import { PageShell } from "@/components/site/PageShell";
import { ContactAside } from "@/components/site/ContactAside";

const TIPS = [
  "Halten Sie Fahrzeugschein und Fahrzeugschlüssel bereit.",
  "Notieren Sie Kennzeichen und Versicherung des Unfallgegners.",
  "Lassen Sie das Fahrzeug möglichst noch nicht reparieren.",
];

export default function ThankYouPage() {
  const { state } = useLocation();
  const isDamage = state?.type === "damage" && state?.ref;

  return (
    <>
      <Seo title="Danke – wir melden uns in Kürze | Marcone" description="Vielen Dank für Ihre Anfrage beim Kfz-Sachverständigen Marcone in Köln." path="/danke" noindex />
      <PageShell
        aside={<ContactAside title="Es eilt?" />}
        asideFirstOnMobile={false}
        hero={<Hero image="real-gutachten-uebergabe" imagePosition="center 35%" imageAlt="Übergabe eines fertigen Kfz-Gutachtens im Büro Marcone" title="Danke – wir melden uns in Kürze" subtitle="Ihre Anfrage ist bei uns eingegangen." badges={false} />}
      >
        <div className="rounded-3xl bg-white p-6 shadow-soft ring-1 ring-slate-200 sm:p-8" data-testid="thank-you-card">
          <CheckCircle2 className="h-10 w-10 text-brand-blue" />
          <h2 className="mt-4 text-2xl font-bold text-brand-anthracite">Vielen Dank für Ihr Vertrauen!</h2>
          <p className="mt-2 leading-relaxed">Wir melden uns meist innerhalb von 30 Minuten bei Ihnen – Montag bis Freitag rund um die Uhr.</p>
          {isDamage && (
            <div className="mt-6 flex items-center gap-4 rounded-2xl bg-brand-yellow/30 p-5 ring-1 ring-brand-yellow">
              <FileText className="h-6 w-6 shrink-0 text-brand-anthracite" />
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-brand-anthracite/70">Ihre Vorgangsnummer</p>
                <p className="text-2xl font-bold tracking-wide text-brand-anthracite" data-testid="thank-you-ref">{state.ref}</p>
              </div>
            </div>
          )}
          <h3 className="mt-8 font-bold text-brand-anthracite">Was Sie jetzt tun können</h3>
          <ul className="mt-3 space-y-2">
            {TIPS.map((t) => <li key={t} className="flex gap-2.5 text-[15px]"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-brand-blue" />{t}</li>)}
          </ul>
          <Link to="/" className="mt-8 inline-flex items-center gap-2 font-bold text-brand-blue hover:underline" data-testid="thank-you-home-link">
            <ArrowLeft className="h-4 w-4" /> Zur Startseite
          </Link>
        </div>
      </PageShell>
    </>
  );
}
